var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 29,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19998 0.0999998C4.19998 0.8 0.999984 3.9 0.199984 7.8C0.099984 8.4 -1.60392e-05 9 -1.60392e-05 9.5C-0.100016 11.2 0.399984 12.8 1.19998 14.3L9.09998 28.4C9.49998 29.1 10.5 29.1 10.9 28.4L18.8 14.2C19.5 13 20 11.5 20 10C20 3.9 14.5 -0.9 8.19998 0.0999998ZM9.99998 14.5C7.19998 14.5 4.99998 12.3 4.99998 9.5C4.99998 6.7 7.19998 4.5 9.99998 4.5C12.8 4.5 15 6.7 15 9.5C15 12.3 12.8 14.5 9.99998 14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.0d97f087ad2ed5246abbdb0cbd79193f.svg";
export { ForwardRef as ReactComponent };